<template>
<!-- 成绩管理 列表页 -->
    <div class="board">
        <div v-hasPermi="['review:plan:list']">
            <div class="title">
                <span class="name">{{ achievementTextConfig.title }}</span>
            </div>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-select v-model="form.examPlanId" filterable clearable :placeholder="searchTextConfig.examPlan">
                        <el-option v-for="(item, index) in examPlanOptions" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.subjectId" filterable clearable :placeholder="searchTextConfig.subjectId">
                        <el-option v-for="(item,index) in subjectOptions" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.examPaperId" filterable clearable :placeholder="searchTextConfig.examPaperId">
                        <el-option v-for="(item,index) in paperNameOptions" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.reviewStatus" clearable :placeholder="searchTextConfig.reviewStatus">
                        <el-option v-for="item in statusOptions" :key="item.dict_value" :label="item.dict_label" :value="item.dict_value" v-if="item.dict_value != 3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ searchTextConfig.button.search }}</el-button>
                    <el-button @click="reset">{{ searchTextConfig.button.reset }}</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="tableData" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading" ref="multipleTable" stripe size="medium" :height="height" style="width:100%">
                <el-table-column prop="examPlanName" :label="tableTextConfig.examPlan" min-width="180px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="subject" :label="tableTextConfig.subject" :min-width="flexColumnWidth('subject',4,tableData)" show-overflow-tooltip></el-table-column>
                <el-table-column prop="examPaperName" :label="tableTextConfig.examPaperName" min-width="180px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="examTime" :label="tableTextConfig.examTime" :formatter="examTimeFormatter" min-width="220px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reviewStartTime" :label="tableTextConfig.reviewStartTime" min-width="180px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reviewEndTime" :label="tableTextConfig.reviewEndTime" min-width="180px"></el-table-column>
                <el-table-column prop="reviewerNum" :label="tableTextConfig.reviewerNum" min-width="80px">
                    <template slot-scope="scope">
                        {{
                            scope.row.haveReviewSubjective ? tableTextConfig.reviewerNumFormatter.signMix(scope.row.reviewerNum) : ''
                        }}
                    </template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.reviewStatus" min-width="125px">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.reviewStatus===1?'warning':scope.row.reviewStatus===2?'success':''">{{ reviewStatusFormatter(scope.row.reviewStatus) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="tableTextConfig.operate" width="300px" align="center">
                    <template slot-scope="scope">
                        <el-button
                            v-hasPermi="['review:result:list']"
                            plain
                            type="primary"
                            size="mini"
                            @click="lookScore(scope.row)">
                            {{ tableTextConfig.button.details.name }}
                        </el-button>
                        <el-button
                            v-hasPermi="[scope.row.reviewStartTime?'review:plan:edit':'review:plan:add']"
                            v-if="scope.row.haveReviewSubjective !== false && scope.row.examCategory !== 'train'"
                            plain
                            type="primary"
                            size="mini"
                            @click="$router.push({name:'reviewPlan',query:{id:scope.row.id,examPaperId:scope.row.examPaperId}})">
                            {{ tableTextConfig.button.edit.name }}
                        </el-button>

                        <el-dropdown @command="handleCommand($event, scope.row)">
                            <el-button type="primary" size="mini" plain>
                                导出<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="answer" v-if="scope.row.examCategory !== 'train'">答卷</el-dropdown-item>
                                <el-dropdown-item command="score" v-hasPermi="['review:plan:export']">成绩</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize" :total.sync="total"></pagination>
            <special-dialog :row.sync="row" :show.sync="specialDialogVisible" @close="close"></special-dialog>
            <export-dialog :row.sync="row" :show.sync="exportDialogVisible" @close="close"></export-dialog>
            <export-answer-dialog :row.sync="row" ref="exportAnswerDialog"></export-answer-dialog>
        </div>
    </div>
</template>

<script>
import specialDialog from './components/special.vue'
import exportDialog from './components/export.vue'
import pagination from '@/components/pagination/pagination.vue'
import exportAnswerDialog from './components/exportAnswer.vue'
import {getDict} from "@/api/dict"
import {exportAnswer} from "@/api/reviewPlan";

export default {
    components: {
        specialDialog, exportDialog, pagination, exportAnswerDialog
    },
    data() {
        return {
            height:250,
            loading: true,
            form: {
                examPaperId: '',
                examPlanId: '',
                reviewStatus: '',
                subjectId: '',
                pageNumber: 1,
                pageSize: 20
            },
            total: 0,
            examPlanOptions: [],
            subjectOptions: [],
            paperNameOptions: [],
            statusOptions: [],
            tableData: [],
            specialDialogVisible: false,
            exportDialogVisible: false,
            row: null,
        }
    },
    computed: {
        achievementTextConfig() {
            return this.$store.state.global.textConfig.backend.achievement
        },
        searchTextConfig() {
            return this.achievementTextConfig.search
        },
        tableTextConfig() {
            return this.achievementTextConfig.table
        }
    },
    watch: {
        tableData () {
            if (this.tableData.length == 0) {
                this.height = 120
            }else {
                this.updateHeight()
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        if (from.name === 'examineeScore') {
            to.meta.isBack = true
        } else {
            to.meta.isBack = false
        }
        next()
    },
    activated() {
        if (!this.$route.meta.isBack) {
            this.reset()
        } else {
            this.$route.meta.isBack = false
            // this.getBorrowList() /*列表重新加载*/
        }
    },
    created() {
        this.$store.dispatch("getExamPlan").then(res => {
            this.examPlanOptions = res.data
        });
        this.$store.dispatch("getExamSubject").then(res => {
            this.subjectOptions = res.data
        });
        this.$store.dispatch("getArrangementExamPaper").then(res => {
            this.paperNameOptions = res.data
        });
        getDict('review_status').then(res => {
            this.statusOptions = res.data
        });
        this.search(1)
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
    methods: {
        handleCommand(command, row) {
            switch (command) {
                case "answer":
                    this.exportAnswer(row)
                    break
                case "score":
                    this.exportDialogVisible = true
                    this.row = row
                    break
            }
        },
        exportAnswer(row) {
            this.row = row
            this.$refs['exportAnswerDialog'].show()
        },
        lookScore(data) {
            localStorage.setItem('setExamineeScoreInfo', JSON.stringify(data))
            this.$router.push({name:'examineeScore'})
        },
        search(val) {
            this.loading = true
            if (val) {
                this.form.pageNumber = val
            }
            this.$store.dispatch("getAchievementList", this.form).then(res => {
                if (res.status==200) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                }
                this.loading = false
                this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            }).catch(err => {
                console.log(err);
                this.loading = false
            })
        },
        reset() {
            this.form = this.$options.data().form
            this.form.pageSize = 20
            this.search(1)
        },
        edit(row) {
            this.row = row
            this.specialDialogVisible = true
        },
        close(data) {
            this.specialDialogVisible = data
            this.exportDialogVisible = data
            this.row = null
        },
        updateHeight() {
            if (document.getElementsByClassName('el-form')[0]) {
                this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 150
                this.height = this.height < 460 ? 460 : this.height
            }
        },
        reviewStatusFormatter(val) {
            let already = this.statusOptions.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        examTimeFormatter(row) {
            return row.startTime + " ~ " + row.endTime
        }
    }
}
</script>
<style scoped>
.cell .el-button {
    margin-left: 0;
    margin-right: 10px;
    margin-top: 10px;
}
</style>
